<template>
  <!-- <div class="mobile-header-container">
    <slot name="header" />
  </div> -->
  <div
    class="page-layout relative bg-grey"
    :class="previsualization ? 'previsualization' : ''"
  >
    <div v-if="previsualization" class="previsualization-dev-banner">
      {{ $t("profiles.texts." + type + "Previsualization") }}
    </div>

    <header class="header-container" role="banner">
      <section class="image" @click="$emit('openGallery')">
        <img
          :src="image || placeholderImg"
          class="object-contain"
          :alt="
            image
              ? $t('profiles.profileLayout', { profile })
              : $t('profiles.notProfileImg', { profile })
          "
          @error="$event.target.src = placeholderImg"
        />
        <div v-if="soldOut === 2" class="status-mask">
          <img
            class="status-img"
            :src="require('@/assets/images/sold-out-text.svg')"
            alt="sold out event"
          />
        </div>
        <div
          v-if="cancelation === 1 || cancelation === 3"
          class="status-mask"
          :class="cancelation === 3 ? 'change-date' : ''"
        >
          <img
            v-if="cancelation === 1"
            class="status-img"
            :src="require('@/assets/images/cancel-text.svg')"
            alt="cancel event"
          />
          <img
            v-else-if="cancelation === 3"
            class="status-img"
            :src="require('@/assets/images/new-date-text.svg')"
            alt="cancel event"
          />
        </div>
        <div :class="cancelation !== 1 ? 'gradient' : ''">
          <!-- <button
            v-if="medias.length > 0"
            class="md:inline-block hidden absolute right-5 h-3"
            @click="showGalleryModal = true"
          >
            <icon
              :img="require('@/assets/images/ic-gallery-linear-topaz.svg')"
              :size="24"
            />
          </button>
          <button
            v-if="medias.length > 0"
            class="md:hidden inline-block absolute right-2 h-3"
            @click="showGalleryModal = true"
          >
            <icon
              :img="require('@/assets/images/ic-gallery-linear-topaz.svg')"
              :size="16"
            />
          </button> -->

          <a
            v-if="
              type === 'event' &&
                eventType === 'concert' &&
                artist.length === 1 &&
                artist[0].spotify_id
            "
            :href="
              `https://open.spotify.com/intl-es/artist/${artist[0].spotify_id}`
            "
            target="_blank"
            class="z-10 flex items-center absolute bottom-5"
          >
            <span
              v-if="type === 'event'"
              class="md:mr-2 md:inline-block hidden"
            >
              <icon
                :img="require('@/assets/images/ic-play-circle-topaz.svg')"
                :size="24"
              />
            </span>
            <span class="flex">
              <p class="md:inline-block hidden">
                Escuchar en
              </p>
              <span class="ml-2 md:inline-block hidden">
                <icon
                  :size="24"
                  :img="require('@/assets/images/ic-spotify-white.svg')"
                />
              </span>
            </span>
          </a>
          <button
            class="share-button block lg:hidden absolute bottom-5 w-auto"
            @click="$emit('update:openShare')"
          >
            <icon
              :img="require('@/assets/images/ic-share-circle-topaz.svg')"
              :size="27"
            />
          </button>
        </div>

        <div v-if="previsualization" class="previsualization-dev"></div>
      </section>
      <slot name="header" />
      <div v-if="previsualization" class="previsualization-dev"></div>
    </header>
    <div class="top-sections">
      <slot name="top-sections" />
    </div>
    <main class="main-profiles" role="main">
      <section class="info-sections">
        <!-- <div class="description">
          <slot name="description" />
          <div
            v-if="previsualization"
            class="previsualization-dev pre-description"
          ></div>
        </div> -->
        <div class="content">
          <slot name="content" />
          <div v-if="previsualization" class="previsualization-dev"></div>
        </div>
      </section>

      <!-- <div class="image">
      <img
        :src="image || placeholderImg"
        :alt="
          image
            ? $t('profiles.profileLayout', { profile })
            : $t('profiles.notProfileImg', { profile })
        "
        loading="lazy"
        @error="$event.target.src = placeholderImg"
      />
      <div v-if="previsualization" class="previsualization-dev"></div>
    </div> -->

      <!-- <div
      class="absolute h-36 w-full bottom-0 bg-gradient-to-grey pointer-events-none"
    ></div> -->
    </main>
  </div>
  <modal-profiles
    v-if="showGalleryModal"
    :title="$t('profiles.titles.gallery')"
    @close="showGalleryModal = false"
  >
    <template #modalProfile>
      <div v-for="media in medias" :key="media.id">
        {{ media }}
      </div>
    </template>
  </modal-profiles>
</template>

<script setup>
import { onMounted, computed, ref, defineAsyncComponent } from "vue";
import Icon from "@/components/general/ui/elements/WIcon.vue";
import { useRoute } from "vue-router";
import { setParameters } from "@/plugins/parameters";
const ModalProfiles = defineAsyncComponent(() =>
  import("@/components/general/modals/ModalProfiles.vue")
);

const props = defineProps({
  image: {
    type: String,
    default: undefined
  },
  profile: {
    type: String,
    default: undefined
  },
  type: {
    type: String,
    default: "event"
  },
  eventType: {
    type: String,
    default: "concert"
  },
  previsualization: {
    type: Boolean,
    default: false
  },
  medias: {
    type: Array,
    default: undefined
  },
  artist: {
    type: Array,
    default: undefined
  },
  cancelation: {
    type: Number,
    default: 0
  },
  soldOut: {
    type: Number,
    default: 0
  }
});
const emit = defineEmits(["update:openShare", "openGallery"]);
const route = useRoute();
const showGalleryModal = ref(false);
// const { image } = toRefs(props);
// const imageBackground = new Image();
// TODO: revisar para que sirve
// image.src = 'url("@/assets/images/background-info.png")';
// image.onload = function() {
//   const backgroundContainer = document.querySelector(".header-container");
//   backgroundContainer.style.backgroundImage = `url(${imageBackground.src})`;
// };

// TODO: Revisar que pasa con las imagenes, pj: artista es cuadrado
const placeholderImg = computed(() => {
  // if (props.type === "venue") {
  //   return require("@/assets/images/venue-placeholder.svg");
  // } else if (props.type === "artist") {
  //   return require("@/assets/images/artist-placeholder.svg");
  // } else if (props.type === "user") {
  //   return require("@/assets/images/placeholder-user.svg");
  // }
  return require("@/assets/images/placeholder-event-dark.svg");
});
onMounted(() => {
  if (route.query.u) {
    setParameters(`u-param-${route.name}`, route, "u");
  }
  if (route.query.r) {
    setParameters(`r-param-${route.name}`, route, "r");
  }
});
</script>

<style lang="scss" scoped>
@import "@/components/general/ui/profiles/profiles.scss";
@import "~@/assets/mixins/delete-scroll.scss";
.page-layout {
  @apply lg:flex flex-col;
  overflow-x: hidden;
  @media screen and (max-width: $screen-lg) {
    background-color: $backgroundBlack;
  }
  .header-container {
    z-index: 3;
    @apply bg-cover;
    height: 180px;
    width: 100%;
    max-width: 1024px;
    gap: 10px;
    display: flex;
    // justify-content: center;
    align-items: center;
    margin: auto;
    padding: 1.375rem 1.063rem 1.063rem 0.813rem; // 28px 15px
    @media screen and (min-width: $screen-sm) {
      padding: 20px 100px;
      width: 100%;
    }
    @media screen and (min-width: $screen-md) {
      gap: 0.875rem;
      padding: 20px 70px;
      // justify-content: start;
    }
    @media screen and (min-width: $screen-lg) {
      height: 440px;
      gap: 0.875rem;
      padding: 1.038rem 0;
      // justify-content: center;
    }
    position: relative;
  }
  .page-info {
    @apply lg:w-1/3 xl:scrollbars-on xl:pb-24;

    .image {
      @apply lg:hidden block;
      aspect-ratio: 1;
      height: 180px;
      cursor: pointer;
      @media screen and (min-width: $screen-lg) {
        height: 369px;
      }
    }

    .description {
      @apply font-museo-500;
      .title {
        @apply font-museo-500 text-xl;
      }
      .text {
        @apply my-4 font-museo-500 text-m text-color-grayLight;
      }
    }
  }

  .page-content {
    @apply lg:w-2/3 xl:scrollbars-on pb-4 xl:pb-24;

    .image {
      @apply lg:block hidden;
    }
  }
}
.content {
  width: 100%;
}

.image {
  height: 128px;
  width: 128px;
  max-width: 400px;
  display: flex;
  justify-content: center;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  @media screen and (min-width: $screen-md) {
    height: 9.125rem;
    width: 9.125rem;
  }
  @media screen and (min-width: $screen-lg) {
    height: 23.875rem;
    width: 23.875rem;
    max-width: 23.875rem;
  }

  > img {
    @apply object-cover w-full h-full;
    border-radius: 10px;
    z-index: 1;
  }
  .gradient {
    background: linear-gradient(
      0deg,
      $backgroundBlack 0%,
      $backgroundGrey-0 60%
    );
    padding: 8px;
    z-index: 2;
    display: flex;
    width: 100%;
    height: 128px;
    position: absolute;
    @media screen and (min-width: $screen-md) {
      height: 160px;
    }
    @media screen and (min-width: $screen-lg) {
      height: 23.875rem;
      padding: 21px 19px;
    }
  }
}

@tailwind base;
@layer base {
  .scrollbars-on {
    @apply h-screen overflow-auto hidden-scrollbars;
  }
}
.previsualization {
  .header-container,
  .image,
  .description,
  .page-content,
  .content {
    position: relative;
  }
  .previsualization-dev {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #00000080;
    &.pre-description {
      margin-left: -29px;
    }
  }
  .previsualization-dev-banner {
    @apply sticky xl:absolute;
    width: 100vw;
    padding: 16px 6px;
    background-color: #00000080;
    font-size: 1.25em;
    text-align: center;
    z-index: 4;
  }
}

.top-sections {
  @apply block lg:hidden py-4;
  background-color: $backgroundGrey;
  position: relative;
  // z-index: 4;
  overflow: scroll;
  scroll-behavior: smooth;
  @include delete-scroll;
  .section {
    @apply cursor-pointer;
  }
}
.description {
  width: 100%;
  display: flex;
  gap: 0.875rem;
}
.info-sections {
  display: flex;
  flex-wrap: wrap;
  gap: 0.875rem;
  @media screen and (min-width: $screen-lg) {
    margin-top: 29px;
  }
}
.main-profiles {
  width: 100%;
  max-width: 2000px;
  margin: auto;
}
.share-button {
  bottom: 9px;
  left: 9px;

  @media screen and (min-width: $screen-md) {
    left: 0.563rem;
    bottom: 0.553rem;
    bottom: 22px;
    left: 9px;
  }
  @media screen and (min-width: $screen-lg) {
    left: 0.563rem;
    bottom: 0.553rem;
  }
}
.status-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 3;
  background-color: $backgroundBlackOpacity7;
  &.change-date {
    width: 100%;
    height: 18%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: $backgroundBlackOpacity7;
    .status-img {
      width: 43%;
      position: relative;
    }
  }
  .status-img {
    width: 70%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
